<template>
	<v-footer id="default-footer" color="#36274C" inset>
		<v-container class="pa-10">
			<v-row>
				<v-col cols="12" md="6">
					<div>
						<span class="orange--text ff-emkan-bold">جت اقساط</span>
						&nbsp;
						<span class="white--text text--darken-2">اولین نرم افزار مدیریت اقساط ابری</span>
					</div>
					<div>
						<v-list nav dense color="transparent">
							<v-list-item>
								<v-list-item-avatar>
									<v-icon class="orange lighten-1" dark>
										mdi-cellphone
									</v-icon>
								</v-list-item-avatar>
								<v-list-item-content>
									<v-list-item-title class="fs-h5 white--text">۰۹۳۶۱۹۹۵۴۳۴</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-list-item>
								<v-list-item-avatar>
									<v-icon class="orange lighten-1" dark>
										mdi-email
									</v-icon>
								</v-list-item-avatar>
								<v-list-item-content>
									<v-list-item-title class="fs-h5 white--text">info@jetaqsaat.ir</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list>
					</div>
					<div style="border-top: 1px solid #5d4c76;padding: 10px 14px;display: flex;justify-content: space-between;">
						<div>
							<small class="white--text">شبکه های اجتماعی:</small>
							<v-btn fab color="#eeeeee" elevation="1" small class="mx-1">
								<v-icon color="orange">mdi-whatsapp</v-icon>
							</v-btn>
							<v-btn fab color="#eeeeee" elevation="1" small class="mx-1">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" style="fill:orange;width:20px">
									<path d="M66.964 134.874s-32.08-10.062-51.344-16.002c-17.542-6.693-1.57-14.928 6.015-17.59 7.585-2.66 186.38-71.948 194.94-75.233 8.94-4.147 19.884-.35 14.767 18.656-4.416 20.407-30.166 142.874-33.827 158.812-3.66 15.937-18.447 6.844-18.447 6.844l-83.21-61.442z" fill="none" stroke="#ff9a51" stroke-width="20" />
									<path d="M92.412 201.62s4.295.56 8.83-3.702c4.536-4.26 26.303-25.603 26.303-25.603" fill="none" stroke="#ff9a51" stroke-width="20" />
									<path d="M66.985 134.887l28.922 14.082-3.488 52.65s-4.928.843-6.25-3.613c-1.323-4.455-19.185-63.12-19.185-63.12z" fill-rule="evenodd" stroke="#ff9a51" stroke-width="20" stroke-linejoin="bevel" />
									<path d="M66.985 134.887s127.637-77.45 120.09-71.138c-7.55 6.312-91.168 85.22-91.168 85.22z" fill-rule="evenodd" stroke="#ff9a51" stroke-width="9.67" stroke-linejoin="bevel" />
								</svg>
							</v-btn>
						</div>
						<a href="https://trustseal.enamad.ir/?id=326953&amp;Code=Ki6utUTExk17V31Nc6Yk" style="display: inline-block;background-color: #eeeeee;border: 2px solid #cfcfcf;border-radius: 5px;">
							<img width="100" height="150" src="https://jetafzaar.ir/wp-content/uploads/2022/08/namad3-216x300.png" class="attachment-medium size-medium" alt="" loading="lazy" srcset="https://jetafzaar.ir/wp-content/uploads/2022/08/namad3-216x300.png 216w, https://jetafzaar.ir/wp-content/uploads/2022/08/namad3-287x400.png 287w, https://jetafzaar.ir/wp-content/uploads/2022/08/namad3.png 319w" sizes="(max-width: 216px) 100vw, 216px">
						</a>
					</div>
				</v-col>
				<v-col cols="12" md="6">
					<div class="fs-h3 orange--text ff-emkan-bold">
						مشاوره رایگان
					</div>
					<div class="white--text text--darken-2">
						اطلاعات تماس خود را ثبت کنید، کارشناسان جت اقساط آماده ارائه خدمات رایگان مشاوره در حوزه راهنمایی خرید و پشتیبانی نرم افزار می باشند.
					</div>
					<div class="mx-auto mb-5 mt-3">
						<v-form ref="consultantForm" lazy-validation class="consultantForm" @submit.prevent="submitConsultant">
							<v-row>
								<v-col cols="12" class="pb-0">
									<v-text-field ref="consultantName" dark v-model="consultant.name" label="نام و نام خانوادگی" :error-messages="errorMessages" :rules="[(value) => !!value || 'نام الزامی است']" required />
								</v-col>

								<v-col cols="12" class="py-0">
									<v-text-field ref="consultantPhone" dark maxlength="20" v-model="consultant.phone" label="شماره تماس خود را وارد کنید" :error-messages="errorMessages" :rules="[(value) => !!value || 'شماره تماس الزامی است']" required />
								</v-col>

								<v-col cols="12" class="py-0">
									<v-textarea v-model="consultant.description" dark maxlength="1000" auto-grow color="deep-purple" label="شرح پیام خود را اینجا وارد کنید" rows="4" :error-messages="errorMessages" :rules="[(value) => !!value || 'شرح را وارد کنید']" required></v-textarea>
								</v-col>

								<v-col cols="12" class="py-0">
									<v-btn :loading="consultantLoading" color="orange" dark type="submit" class="mb-2">ارسال درخواست</v-btn>
									<div v-show="consultantSummery" class="pa-2 mt-2" :class="consultantSummeryColor">
										{{ consultantSummery }}
									</div>
								</v-col>

							</v-row>
						</v-form>
					</div>
				</v-col>
			</v-row>
		</v-container>
		<div class="text-center grey--text fs-h6 pt-1" style="border-top:1px solid #5d4c76;width:100%">
			کلیه حقوق این سایت متعلق به جت اقساط می‌باشد. کپی رایت {{ year }} ©
		</div>
	</v-footer>
</template>

<script>
	// Components
	import api from '@/util/app-api'
	import Links from '@/components/Links'

	export default {
		name: 'DefaultFooter',

		components: { Links },

		data: () => ({
			errorMessages: '',
			consultantSummeryColor: '',
			consultant: { name: '', phone: '', description: '' },
			consultantLoading: false,
			consultantSummery: '',
		}),
		computed: {
			year() {
				let today = new Date().toLocaleDateString('fa-IR')
				return today.substring(0, 4)
			}
		},
		methods: {
			submitConsultant() {
				if (!this.$refs.consultantForm.validate()) { return }

				this.consultantSummery = ''
				this.consultantLoading = true
				this.consultantSummeryColor = ''

				api.post('consultant/create', this.consultant, { authHeader: false })
					.then(response => {
						this.consultantSummery = 'درخواست با موفقیت ثبت شد.'
						this.consultant = { name: '', phone: '', description: '' }
						this.consultantSummeryColor = 'success'
					})
					.catch(err => {
						this.consultantSummery = err.message
						this.consultantSummeryColor = 'error'
					})
					.finally(() => {
						this.consultantLoading = false
					})
			}
		}
	}
</script>
<style >
	.consultantForm .v-input__slot {
		background: #29193c;
	}
</style>
